import moment from 'moment';
import i18n from 'i18next';

// `en` ships with moment itself, so only the other two need importing.
import 'moment/locale/pt-br';
import 'moment/locale/es';

import { toMomentLocale } from './constants';

/**
 * Keeps moment's global locale in sync with the active app language.
 *
 * Apollo cache invalidation lives in `ExtendedApolloProvider` because it needs
 * the client instance; this module owns the framework-agnostic side effects.
 */
const syncMomentLocale = (language: string) => {
  moment.locale(toMomentLocale(language));
};

// Apply the current language on boot and on every change.
syncMomentLocale(i18n.language);
i18n.on('languageChanged', syncMomentLocale);

export default syncMomentLocale;
